import { getCalculatedSum } from '../utils/global';
import { BettingSystem } from './systems/betting-system';

const bs = new BettingSystem();

export function initHistory() {
    bs.init();
}

/** Public **/
export function setMaxLimits(limits: number[]) {
    bs.setLimits(limits);
}

export function placeBet(betId: number, chipSize: number) {
    bs.executePlaceBetCommand(betId, chipSize);
    return bs.getBets();
}

export function betLeft(chipSize: number) {
    bs.executeBetLeftCommand(chipSize);
    return bs.getBets();
}

export function betRight(chipSize: number) {
    bs.executeBetRightCommand(chipSize);
    return bs.getBets();
}

export function undoBet() {
    bs.executeUndoCommand();
    return bs.getBets();
}

export function resetBets() {
    bs.reset();
    return bs.getBets();
}

export function double() {
    bs.executeDoubleCommand();
    return bs.getBets();
}

export function getBets() {
    return bs.getBets();
}

export function canUndo() {
    return bs.getHistorySize() > 0;
}

export function calculateTotalBet(): number {
    return getCalculatedSum(bs.getLimitedBetPerColor());
}

export function getBetPerColor(): number[] {
    return bs.getLimitedBetPerColor();
}
